var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.objClass,attrs:{"id":"flag"}},[_c('i',{staticClass:"fas fa-flag",attrs:{"id":"base"}}),(_vm.wrong)?_c('i',{staticClass:"fas fa-times",attrs:{"id":"cross"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }